import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastrService } from 'ngx-toastr';
import {
  OrderPdfStatus,
  isPdfReady,
  normalizePdfStatus
} from 'src/entities/order/model/order-status.model';
import { getServicePurchaseNoteId } from 'src/entities/purchase-note';
import { buildPurchaseNotePdfDialogConfig } from '../purchase-note-pdf-dialog/purchase-note-pdf-dialog.config';
import {
  PurchaseNotePdfDialogComponent,
  PurchaseNotePdfDialogResult
} from '../purchase-note-pdf-dialog/purchase-note-pdf-dialog.component';

@Component({
  selector: 'app-purchase-note-pdf-button',
  standalone: true,
  templateUrl: './purchase-note-pdf-button.component.html',
  styleUrls: ['./purchase-note-pdf-button.component.css'],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule]
})
export class PurchaseNotePdfButtonComponent {
  @Input() row: any;
  @Input() model: any[] = [];
  @Output() pdfStatusChanged = new EventEmitter<void>();

  readonly OrderPdfStatus = OrderPdfStatus;

  constructor(
    private readonly toastr: ToastrService,
    private readonly dialog: MatDialog
  ) {}

  get visible(): boolean {
    return Boolean(getServicePurchaseNoteId(this.row));
  }

  get pdfStatus(): OrderPdfStatus | null {
    return normalizePdfStatus(this.row?.purchaseNote?.pdfStatus ?? null);
  }

  get isGenerated(): boolean {
    return isPdfReady(this.row?.purchaseNote?.pdfStatus);
  }

  openPdfDialog(): void {
    const purchaseNoteId = getServicePurchaseNoteId(this.row);

    if (!purchaseNoteId) {
      this.toastr.warning('No se encontró la Orden de pedido.');
      return;
    }

    this.dialog
      .open(
        PurchaseNotePdfDialogComponent,
        buildPurchaseNotePdfDialogConfig({
          purchaseNoteId,
          purchaseNoteNumber: this.row?.purchaseNote?.purchaseNoteNumber,
          pdfStatus: this.row?.purchaseNote?.pdfStatus,
          lastPdfError: this.row?.purchaseNote?.lastPdfError
        })
      )
      .afterClosed()
      .subscribe((result: PurchaseNotePdfDialogResult | undefined) => {
        if (!result?.pdfStatus) {
          return;
        }

        this.patchLocalPdfStatus(
          result.pdfStatus,
          result.pdfGeneratedAt ?? null,
          result.lastPdfError ?? null
        );
        this.pdfStatusChanged.emit();
      });
  }

  private patchLocalPdfStatus(
    pdfStatus: string,
    pdfGeneratedAt: string | null,
    lastPdfError: string | null = null
  ): void {
    this.row.purchaseNote = {
      ...(this.row.purchaseNote ?? {}),
      pdfStatus,
      pdfGeneratedAt,
      lastPdfError
    };

    if (!this.model?.length) {
      return;
    }

    const noteId = String(getServicePurchaseNoteId(this.row) ?? '');
    for (const service of this.model) {
      const serviceNoteId = String(getServicePurchaseNoteId(service) ?? '');
      if (noteId && serviceNoteId === noteId) {
        service.purchaseNote = {
          ...(service.purchaseNote ?? {}),
          pdfStatus,
          pdfGeneratedAt,
          lastPdfError
        };
      }
    }
  }
}
